export default __webpack_public_path__ + "static/media/kavanaugh.2c7cb9e9.jpg";